<template>
  <div class="sku-order-information">
    <div class="sku-order-information__content">
      <h5 class="title">PRISM Electronics needs:</h5>
      <ul class="list">
        <li>Delivery of <span>300,000</span> boxes to fill lines by December (100,000 boxes delivered per month)</li>
        <li>PRISM provided the quantity breakdown for all <span>5 SKUs</span></li>
        <li>Requested deliveries to fill lines <span>starting September</span></li>
      </ul>
      <img class="image" src="images/why-digital/manufacturing-benefits/scenario_2_manufacturing_benefits.png" alt="">
    </div>
    <div class="table-container-manufacturing">
      <table>
        <tr>
          <th style="background:transparent; border:none;"></th>
          <th style="background:#474C56;border-start-start-radius: 8px;">AUG</th>
          <th style="background:#5F646E;">SEP</th>
          <th style="background:#474C56;">OCT</th>
          <th style="background:#5F646E;">NOV</th>
          <th style="background:#474C56;border-start-end-radius: 8px;">DEC</th>
        </tr>
        <tr>
          <td class="name-row-cell first">SKU 1<br><span>Structure A</span></td>
          <td>-</td>
          <td>30,000</td>
          <td>30,000</td>
          <td>30,000</td>
          <td>-</td>
        </tr>
        <tr>
          <td class="name-row-cell">SKU 2<br><span>Structure A</span></td>
          <td>-</td>
          <td>30,000</td>
          <td>30,000</td>
          <td>30,000</td>
          <td>-</td>
        </tr>
        <tr>
          <td class="name-row-cell">SKU 3<br><span>Structure A</span></td>
          <td>-</td>
          <td>25,000</td>
          <td>25,000</td>
          <td>25,000</td>
          <td>-</td>
        </tr>
        <tr>
          <td class="name-row-cell">SKU 4<br><span>Structure A</span></td>
          <td>-</td>
          <td>10,000</td>
          <td>10,000</td>
          <td>10,000</td>
          <td>-</td>
        </tr>
        <tr>
          <td class="name-row-cell last">SKU 5<br><span>Structure A</span></td>
          <td>-</td>
          <td>5,000</td>
          <td>5,000</td>
          <td>5,000</td>
          <td>-</td>
        </tr>
        <tr class="total-row">
          <td class="title-row" style="border-end-start-radius: 8px;">TOTAL:</td>
          <td>-</td>
          <td>100,000</td>
          <td>100,000</td>
          <td>100,000</td>
          <td style="border-end-end-radius: 8px;">-</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/scss/views/why-digital/manufacturing-time.scss";
@import '@/scss/_mixins.scss';
</style>
